uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

// https://iquilezles.org/articles/distgradfunctions2d/

vec3 sdgHeart(in vec2 p) {
    float sx = (p.x < 0.0) ? -1.0 : 1.0;
    p.x = abs(p.x);

    if(p.y + p.x > 1.0) {
        const float r = sqrt(2.0) / 4.0;
        vec2 q0 = p - vec2(0.25, 0.75);
        float l = length(q0);
        vec3 d = vec3(l - r, q0 / l);
        d.y *= sx;
        return d;
    } else {
        vec2 q1 = p - vec2(0.0, 1.0);
        vec3 d1 = vec3(dot(q1, q1), q1);
        vec2 q2 = p - 0.5 * max(p.x + p.y, 0.0);
        vec3 d2 = vec3(dot(q2, q2), q2);
        vec3 d = (d1.x < d2.x) ? d1 : d2;
        d.x = sqrt(d.x);
        d.yz /= d.x;
        d *= (p.x > p.y) ? 1.0 : -1.0;
        d.y *= sx;
        return d;
    }
}

vec3 sdgRound( in vec3 shape, in float r )
{
    return vec3( shape.x - r, shape.yz );
}

void main() {
    vec2 st = gl_FragCoord.xy / resolution.xy;
    vec2 uv = vUv;
    // uv -= 5.;
    vec2 p = uv * resolution;

    float v = 0.;

    p = mod(p, 50.);
    p = p / 50.0;
    p = (p * 2.) - vec2(1.0, 0.3);
    p = p * 0.6;
    v = p.x * p.y;
    vec3 heart = sdgRound(sdgHeart(p), 0.1);

    v = smoothstep(-0.2, -0.15, heart.x);

    heart.yz = clamp(heart.yz, vec2(0.), vec2(0.2));
    
    vec3 aColor1 = vec3(0.45);
    vec3 aColor2 = vec3(0.30);
    vec3 aColor12 = mix(aColor1, aColor2, heart.y);

    vec3 aColor3 = vec3(0.48);
    vec3 aColor4 = vec3(0.20);
    vec3 aColor34 = mix(aColor3, aColor4, heart.z);

    vec3 aColor = aColor12 + aColor34;

    vec3 bColor = vec3(0.0);

    gl_FragColor = vec4(mix(aColor, bColor, v).rgb, 1.0);
}